import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import PriceOfferProgressBar from "@/pages/price-offer/components/PriceOfferProgressBar";
import { useEffect } from "react";
import { useTranslation } from "@i18n";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import DaysComponent, { DaysComponentSkeleton } from "@/pages/price-offer/components/DaysComponent";
import TimeSlots, { TimeSlotsSkeleton } from "@/pages/price-offer/components/TimeSlots";
import { twMerge } from "tailwind-merge";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
import useBrandsData from "@hooks/useBrandsData";
import { toast } from "sonner";
import useBoolean from "@hooks/useBoolean";
import { LoaderIcon } from "react-hot-toast";
var PriceOfferInspectionDatePage = function PriceOfferInspectionDatePage() {
  var _scheduleData$selecte, _scheduleData$selecte2;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _usePriceOfferContext = usePriceOfferContext(),
    state = _usePriceOfferContext.state,
    remote_actions = _usePriceOfferContext.remote_actions,
    helpers = _usePriceOfferContext.helpers,
    scheduleData = _usePriceOfferContext.scheduleData,
    actions = _usePriceOfferContext.actions,
    constants = _usePriceOfferContext.constants,
    selectedCity = _usePriceOfferContext.selectedCity,
    daysLoader = _usePriceOfferContext.daysLoader,
    slotsLoader = _usePriceOfferContext.slotsLoader;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useBrandsData = useBrandsData({
      forcedLang: "en"
    }),
    getMakeById = _useBrandsData.getMakeById,
    getModelById = _useBrandsData.getModelById;
  var buttonLoading = useBoolean();
  useEffect(function () {
    remote_actions.fetch_availableScheduleDays().then();
  }, []);
  var renderDays = function renderDays() {
    if (daysLoader.value) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DaysComponentSkeleton, null));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DaysComponent, {
      myTimestamp: scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.myTimestamp
      // @ts-ignore
      ,
      availableDays: scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.availableDays,
      selectDay: function selectDay(timestamp) {
        actions.setSelectedTimestamp(timestamp);
        actions.setSelectedDayAndTime({
          from: null,
          to: null
        });
      }
    }));
  };
  var renderTimeSlots = function renderTimeSlots() {
    if (slotsLoader.value || daysLoader.value) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TimeSlotsSkeleton, null));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TimeSlots, null));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PriceOfferProgressBar, null), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary text-start text-lg font-bold"
  }, tShort("price_offer/inspection_date_title", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-start text-base font-bold"
  }, tShort("price_offer/choose_day", {
    ns: "web_sell_trade"
  }))), scheduleData !== null && scheduleData !== void 0 && scheduleData.selectedTimestamp ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, helpers === null || helpers === void 0 ? void 0 : helpers.getSelectedTimeStamp)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse space-y-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-300 rounded w-1/2"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 mb-12 md:mb-0"
  }, /*#__PURE__*/React.createElement("div", null, renderDays()), /*#__PURE__*/React.createElement("div", {
    className: "h-px w-full bg-gray-gainsboro"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-start text-base font-bold"
  }, tShort("price_offer/choose_time", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", null, renderTimeSlots())))))), /*#__PURE__*/React.createElement("div", {
    className: "fixed bg-white bottom-0 w-full left-0 px-4 py-6 md:relative md:p-0 rounded-t-2xl rounded-b-none shadow-[0px_-4px_16px_rgba(0,0,0,0.08)] md:shadow-none md:rounded-none md:pt-12"
  }, /*#__PURE__*/React.createElement("div", {
    // add box shadow top
    className: "w-full flex justify-between gap-4 md:gap-3  md:pt-6 md:border-t md:border-solid md:border-gray-gainsboro md:mt-6 md:justify-between md:border-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-sm font-bold"
  }, helpers.getSelectedTimeStampWithDayPrefix()), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-sm font-bold"
  }, helpers.getSelectedTimeRange())), /*#__PURE__*/React.createElement("button", {
    className: twMerge("transition-colors duration-200 ease-in max-w-[140px] break-all", "w-full p-3 bg-primary text-white rounded text-center font-bold border-none outline-none text-base md:max-w-[200px] cursor-pointer hover:bg-primary-120 transition-colors duration-200 ease-in", "disabled:bg-[#E8EFF6] disabled:text-[#92A5C1] disabled:cursor-not-allowed disabled:pointer-events-none", buttonLoading.value && "flex justify-center items-center pointer-events-none"),
    disabled: !(scheduleData !== null && scheduleData !== void 0 && scheduleData.selectedTimestamp) || !(scheduleData !== null && scheduleData !== void 0 && (_scheduleData$selecte = scheduleData.selectedDayAndTime) !== null && _scheduleData$selecte !== void 0 && _scheduleData$selecte.from) || !(scheduleData !== null && scheduleData !== void 0 && (_scheduleData$selecte2 = scheduleData.selectedDayAndTime) !== null && _scheduleData$selecte2 !== void 0 && _scheduleData$selecte2.to),
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var schedule, _state$offerData, _state$offerData2, _selectedCity$inspect, _selectedCity$inspect2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            buttonLoading.setTrue();
            _context.n = 1;
            return remote_actions.fetch_confirmInspectionAppointment();
          case 1:
            schedule = _context.v;
            if (schedule) {
              navigateTo(constants.inspection_success_url(state === null || state === void 0 ? void 0 : state.request_id));
              trackEvents("sell_car_appointment_book", {
                car_make: getMakeById(Number(state === null || state === void 0 ? void 0 : (_state$offerData = state.offerData) === null || _state$offerData === void 0 ? void 0 : _state$offerData.make_id)),
                car_model: getModelById(Number(state === null || state === void 0 ? void 0 : (_state$offerData2 = state.offerData) === null || _state$offerData2 === void 0 ? void 0 : _state$offerData2.model_id)),
                inspection_city: selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.name_ar,
                inspection_location: selectedCity === null || selectedCity === void 0 ? void 0 : (_selectedCity$inspect = selectedCity.inspection_location) === null || _selectedCity$inspect === void 0 ? void 0 : (_selectedCity$inspect2 = _selectedCity$inspect[0]) === null || _selectedCity$inspect2 === void 0 ? void 0 : _selectedCity$inspect2.location_name_ar,
                appointment_type: "final_inspection",
                order_id: state === null || state === void 0 ? void 0 : state.request_id
              });
            } else {
              toast.error("Failed to confirm appointment. Please try again.", {
                duration: 5000,
                position: "top-center"
              });
            }
            buttonLoading.setFalse();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))
  }, buttonLoading.value ? /*#__PURE__*/React.createElement(LoaderIcon, null) : tShort("price_offer/confirm_appointment", {
    ns: "web_sell_trade"
  }))))));
};
export default PriceOfferInspectionDatePage;